<template>
  <header>
    <Button
      v-if="!['/'].includes($route.path)"
      variant="outline"
      url="/"
      text="Zurück"
      class="back-to-home"
    />
    <a href="https://www.danogips.de/" target="_blank">
      <img alt="Danogips" :src="require('@/assets/img/logo.png')" />
    </a>
  </header>
</template>

<script>
import Button from '@/components/Button.vue';
export default {
  name: 'Header',
  components: {
    Button,
  },
};
</script>

<style lang="scss" scoped>
/* Header */
header {
  background-color: $color-white;
  display: block;
  height: 60px;
  left: 0;
  padding: 18px 0 17px;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 50;

  @include center-max-width-for-layers;

  .back-to-home {
    width: auto !important;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 20px;
    top: 0;
    height: 100%;
    border: none;

    @media screen and (max-width: 768px) {
      content: '';
    }
  }

  img {
    display: inline-block;
    height: 25px;
    vertical-align: bottom;
    width: 150px;
  }
}
</style>
